import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  notFound: {
    textAlign: 'justify',
    fontWeight: 500,
    color: theme.palette.error.remove,
    background: theme.palette.error.background,
    padding: 20,
    lineHeight: '16px',
    borderRadius: 10,

    '& > div': {
      display: 'flex',
      alignItems: 'flex-start',
      gap: 20,
    },

    '& > div > img': {
      marginRight: '0.429em',
      marginBottom: '0.25em',
      verticalAlign: 'middle',
      color: theme.palette.error.main,
    },

    [theme.breakpoints.down(550)]: {
      textAlign: 'left',
      fontSize: 10,
    },
  },

  errorMessage: {
    alignSelf: 'center',
  },
}));
export default useStyles;
